/* ── FAITHWRLD THEME — faithwrld.js ── */
(function () {
  'use strict';

  window.closeAllDrawers = function () {
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.getElementById('search-drawer')?.classList.remove('open');
    document.getElementById('mobile-nav')?.classList.remove('open');
    document.body.classList.remove('overlay-open');
  };

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    reveals.forEach(el => obs.observe(el));
  }

  // Marquee pause
  const marquee = document.querySelector('.marquee-track');
  if (marquee) {
    marquee.addEventListener('mouseenter', () => marquee.style.animationPlayState = 'paused');
    marquee.addEventListener('mouseleave', () => marquee.style.animationPlayState = 'running');
  }

  // Format money
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  }

  // Update cart count badges
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('#cart-count, .cart-badge').forEach(el => el.textContent = cart.item_count);
      return cart;
    } catch (e) { return null; }
  }

  // Add to cart
  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  // Open cart drawer
  function openCartDrawer() {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.body.classList.add('overlay-open');
    refreshCartDrawer();
  }

  // Refresh cart drawer HTML
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const body = document.getElementById('cart-drawer-body');
      const footer = document.getElementById('cart-drawer-footer');
      if (!body) return;

      const subtotalEl = document.getElementById('cart-subtotal-price');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      document.querySelectorAll('#cart-count,.cart-badge').forEach(el => el.textContent = cart.item_count);

      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-empty"><svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your cart is empty</p><a href="/collections/all" class="btn-primary" onclick="closeAllDrawers()">Shop Now</a></div>`;
        if (footer) footer.style.display = 'none';
        return;
      }
      if (footer) footer.style.display = 'block';

      const itemsHtml = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item-img">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="80" height="80" loading="lazy">` : `<div class="cart-item-img-placeholder">FW</div>`}
          </a>
          <div class="cart-item-info">
            <div class="cart-item-header">
              <a href="${item.url}" class="cart-item-title">${item.product_title.toUpperCase()}</a>
              <button class="cart-item-remove" data-key="${item.key}">✕</button>
            </div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-item-footer">
              <div class="cart-item-qty">
                <button class="cart-qty-btn" data-key="${item.key}" data-action="decrease">−</button>
                <span class="cart-qty-val">${item.quantity}</span>
                <button class="cart-qty-btn" data-key="${item.key}" data-action="increase">+</button>
              </div>
              <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            </div>
          </div>
        </div>`).join('');
      body.innerHTML = `<div class="cart-items">${itemsHtml}</div>`;
    } catch (e) { console.error(e); }
  }

  // Cart drawer item interactions
  document.addEventListener('click', async function (e) {
    const removeBtn = e.target.closest('.cart-item-remove');
    if (removeBtn) {
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: removeBtn.dataset.key, quantity: 0 }) });
      await refreshCartDrawer();
      return;
    }
    const qtyBtn = e.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const current = parseInt(qtyBtn.parentElement.querySelector('.cart-qty-val')?.textContent || 1);
      const newQty = qtyBtn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: newQty }) });
      await refreshCartDrawer();
      await updateCartCount();
      return;
    }
  });

  // Cart page qty buttons
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.qty-btn-sm');
    if (!btn) return;
    const key = btn.dataset.key;
    const input = document.querySelector(`.qty-input-sm[data-key="${key}"]`);
    if (!input) return;
    const newQty = btn.dataset.action === 'increase' ? parseInt(input.value) + 1 : Math.max(0, parseInt(input.value) - 1);
    input.value = newQty;
    const res = await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: newQty }) });
    const cart = await res.json();
    await updateCartCount();
    const sub = document.getElementById('cart-page-subtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (newQty === 0) btn.closest('.cart-page-item')?.remove();
  });

  // Cart page remove
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.cart-page-remove');
    if (!btn) return;
    await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }) });
    btn.closest('.cart-page-item')?.remove();
    await updateCartCount();
  });

  // Quick add
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.product-quick-add');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const orig = btn.innerHTML;
    btn.textContent = 'Adding...'; btn.disabled = true;
    try {
      await addToCart(variantId);
      await updateCartCount();
      btn.textContent = '✓ Added!'; btn.style.cssText = 'background:#111;color:#fff';
      openCartDrawer();
      setTimeout(() => { btn.innerHTML = orig; btn.style.cssText = ''; btn.disabled = false; }, 2000);
    } catch { btn.innerHTML = orig; btn.disabled = false; }
  });

  // Product page: gallery thumbs
  const mainImgs = document.querySelectorAll('.gallery-main-img');
  const thumbs = document.querySelectorAll('.gallery-thumb');
  let currentIdx = 0;
  function setGallery(i) {
    currentIdx = i;
    mainImgs.forEach((el, j) => el.classList.toggle('active', i === j));
    thumbs.forEach((el, j) => el.classList.toggle('active', i === j));
  }
  thumbs.forEach(t => t.addEventListener('click', () => setGallery(+t.dataset.index)));

  // Lightbox
  const lightbox = document.getElementById('gallery-lightbox');
  const lbWrap = document.getElementById('lightbox-img-wrap');
  if (lightbox) {
    mainImgs.forEach((img, i) => img.addEventListener('click', () => {
      if (lbWrap) lbWrap.innerHTML = img.innerHTML;
      lightbox.classList.add('open'); currentIdx = i;
    }));
    document.getElementById('lightbox-prev')?.addEventListener('click', () => {
      setGallery((currentIdx - 1 + mainImgs.length) % mainImgs.length);
      if (lbWrap) lbWrap.innerHTML = mainImgs[currentIdx].innerHTML;
    });
    document.getElementById('lightbox-next')?.addEventListener('click', () => {
      setGallery((currentIdx + 1) % mainImgs.length);
      if (lbWrap) lbWrap.innerHTML = mainImgs[currentIdx].innerHTML;
    });
    lightbox.addEventListener('click', e => { if (e.target === lightbox) lightbox.classList.remove('open'); });
  }

  // Product page: variant selector
  const variantDataEl = document.getElementById('variant-data');
  if (variantDataEl) {
    const variantData = JSON.parse(variantDataEl.textContent);
    let selectedOptions = {};
    const currentVariant = JSON.parse(document.getElementById('current-variant-data')?.textContent || 'null');
    if (currentVariant) currentVariant.options.forEach((val, i) => { selectedOptions[i + 1] = val; });

    document.querySelectorAll('[data-option-position]').forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = parseInt(btn.dataset.optionPosition);
        selectedOptions[pos] = btn.dataset.value;
        document.querySelectorAll(`[data-option-position="${pos}"]`).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const label = btn.closest('.product-option')?.querySelector('.option-selected-value');
        if (label) label.textContent = btn.dataset.value;
        const matched = variantData.find(v => Object.entries(selectedOptions).every(([p, val]) => v[`option${p}`] === val));
        if (!matched) return;
        const vidInput = document.getElementById('variant-id-input');
        if (vidInput) vidInput.value = matched.id;
        const priceEl = document.getElementById('product-price');
        if (priceEl) {
          priceEl.innerHTML = matched.compare_at_price > matched.price
            ? `<span class="product-price-sale">${formatMoney(matched.price)}</span><span class="product-price-compare">${formatMoney(matched.compare_at_price)}</span><span class="product-sale-badge">SALE</span>`
            : `<span class="product-price-current">${formatMoney(matched.price)}</span>`;
        }
        const atcBtn = document.getElementById('add-to-cart-btn');
        if (atcBtn) {
          atcBtn.disabled = !matched.available;
          atcBtn.classList.toggle('btn-atc-soldout', !matched.available);
          atcBtn.innerHTML = matched.available ? `<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Add to Cart` : 'Sold Out';
        }
        const url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);
      });
    });
  }

  // Product qty
  const qtyInp = document.getElementById('quantity');
  document.getElementById('qty-minus')?.addEventListener('click', () => { if (qtyInp && qtyInp.value > 1) qtyInp.value--; });
  document.getElementById('qty-plus')?.addEventListener('click', () => { if (qtyInp) qtyInp.value++; });

  // Product ATC form
  document.getElementById('product-form')?.addEventListener('submit', async function (e) {
    e.preventDefault();
    const btn = document.getElementById('add-to-cart-btn');
    const origHTML = btn?.innerHTML;
    const variantId = document.getElementById('variant-id-input')?.value;
    const qty = parseInt(document.getElementById('quantity')?.value) || 1;
    if (!variantId) return;
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    try {
      await addToCart(variantId, qty);
      await updateCartCount();
      if (btn) btn.innerHTML = '✓ Added!';
      const toast = document.getElementById('atc-toast');
      if (toast) { toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 3500); }
      openCartDrawer();
      setTimeout(() => { if (btn) { btn.innerHTML = origHTML; btn.disabled = false; } }, 2000);
    } catch { if (btn) { btn.textContent = 'Error'; btn.disabled = false; setTimeout(() => btn.innerHTML = origHTML, 2000); } }
  });

  // Accordions
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = document.getElementById(`accordion-${trigger.dataset.accordion}`);
      if (!body) return;
      const open = body.classList.toggle('open');
      trigger.classList.toggle('active', open);
    });
  });

  // Collection grid toggle
  document.querySelectorAll('.grid-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.grid-toggle').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const grid = document.getElementById('collection-grid');
      if (grid) grid.style.gridTemplateColumns = `repeat(${btn.dataset.cols}, 1fr)`;
    });
  });

  // Collection filter accordions
  document.querySelectorAll('.filter-group-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      document.getElementById(`filter-${trigger.dataset.filter}`)?.classList.toggle('open');
    });
  });

  window.applyPriceFilter = function () {
    const url = new URL(window.location.href);
    const min = document.getElementById('filter-price-min')?.value;
    const max = document.getElementById('filter-price-max')?.value;
    if (min) url.searchParams.set('filter.v.price.gte', min);
    if (max) url.searchParams.set('filter.v.price.lte', max);
    window.location = url.toString();
  };

  // ESC to close
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAllDrawers(); });

})();
